// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 1rem;
  gap: 1.25rem;
}

.sidebar-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  gap: 1rem;
}

.session-btn {
  margin-bottom: 0.5rem;
}

.sidebar-box-link {
  color: #4648aa;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  margin-top: 0.5rem;
  text-align: center;
}

.upcoming-heading {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.help {
  color: #4648aa;
  text-decoration: none;
  margin-top: 0.5rem;
}

.group-box {
  margin-bottom: -19px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.members-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background-color: #f5f5f5;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  cursor: pointer;
}

.members-text {
  margin-left: 8px;
  flex-grow: 1;
}

.members-box:hover {
  background-color: #eeeeee;
}

.text-left {
  text-align: left;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".sidebar {\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n  padding: 1rem;\n  gap: 1.25rem;\n}\n\n.sidebar-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  padding: 1rem;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}\n\n.session-btn {\n  margin-bottom: 0.5rem;\n}\n\n.sidebar-box-link {\n  color: #4648aa;\n  font-size: 14px;\n  font-weight: bold;\n  text-decoration: none;\n  margin-top: 0.5rem;\n  text-align: center;\n}\n\n.upcoming-heading {\n  display: flex;\n  font-size: 1.2rem;\n  margin-bottom: 0.5rem;\n}\n\n.help {\n  color: #4648aa;\n  text-decoration: none;\n  margin-top: 0.5rem;\n}\n\n.group-box {\n  margin-bottom: -19px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.members-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  background-color: #f5f5f5;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  cursor: pointer;\n}\n\n.members-text {\n  margin-left: 8px;\n  flex-grow: 1;\n}\n\n.members-box:hover {\n  background-color: #eeeeee;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
